import { styled } from '@mui/material/styles';

export const CarouselPaginationContainer = styled('div', {
    name: 'Carousel',
    slot: 'paginationContainer',
    skipSx: false,
})({
    display: 'flex',
    position: 'absolute',
    transition: '300ms',
    bottom: '25px',
    width: '100%',
    zIndex: '2',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
});
